var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer mainFooter"},[_vm._v("E-learning CopyRight © 2021")])
}
var staticRenderFns = []

export { render, staticRenderFns }